import { createSlice } from '@reduxjs/toolkit'
import name from './name'

export const skillBiteList = createSlice({
  name,
  initialState: {
    list: [],
    total: 0
  },
  reducers: {
    getSkillBiteList: (state, { payload }) => {
      state.list = payload.skillBites
      state.total = payload.total
    },
    addSkillBiteList: (state, { payload }) => {
      state.list = state.list.concat(payload.skillBites)
      state.total = payload.total
    }
  }
})

export const { getSkillBiteList, addSkillBiteList } = skillBiteList.actions

export default skillBiteList.reducer
